import BaseView from './BaseView';
import {gsap} from "gsap";
import PeopleTeam from "../../components/PeopleTeam";
import Tabs from "../../components/Tabs";

let view = null;

class People extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {

		// Tabs
		this.tabSection = this.container.querySelector('[data-tab-section]');
		if(this.tabSection) {
			this.tabs = new Tabs(this.tabSection);
		}


		this.breakpoint = window.matchMedia('(max-width:991px)');

		this.peopleTeam = this.container.querySelector('[data-people-team]');
		this.persons = this.peopleTeam.querySelectorAll('[data-person]');
		this.aboutContainer = this.container.querySelector('[data-about-container]');


		if (this.breakpoint.matches) { // mobile
			if (this.peopleTeam) {
				new PeopleTeam(this.peopleTeam);
			}
		}else { // desktop
			this.persons.forEach(person => {

				person.addEventListener("mouseenter", e => {
					// Fade out all persons
					gsap.fromTo(this.persons, {
						opacity: 1
					}, {
						opacity: 0.3
					});

					// Don't fade out hovered person
					gsap.to(e.target, {
						overwrite: true
					});


					// Add About text in container & show
					this.aboutContainer.innerHTML = person.dataset.aboutText;

					gsap.to(this.aboutContainer, {
						opacity: 1,
						ease: "sine.inOut",
						duration: 0.3,
					});
				});


				person.addEventListener("mouseleave", e => {
					// Fade in all persons
					gsap.to(this.persons, {
						opacity: 1,
						ease: "none",
						duration: 0.3
					});

					// Hide about container
					gsap.to(this.aboutContainer, {
						opacity: 0,
						ease: "sine.inOut",
						duration: 0.3,
					});
				});
			});

		}
	}
}


export default {
	namespace: 'template-people',
	beforeEnter: ({ current, next, trigger }) => {
		view = new People(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};